import React, { memo } from 'react';
import {
	ResponsiveContainer,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
} from 'recharts';
import type { HourlyThroughputItem } from '../types/types';

type HourlyThroughputChartProps = {
	data: HourlyThroughputItem[];
};

const axisStyle = { fontSize: 12, fill: '#B3B3B3' };

// 리셉션 상세 - 시간대별 처리량 (막대 차트)
const HourlyThroughputChart = memo<HourlyThroughputChartProps>(({ data }) => {
	return (
		<ResponsiveContainer width="100%" height={220}>
			<BarChart data={data} margin={{ top: 10, right: 10, bottom: 0, left: 0 }}>
				<CartesianGrid stroke="#F3F3F3" vertical={false} />
				<XAxis dataKey="timeRange" tick={axisStyle} tickLine={false} axisLine={{ stroke: '#F3F3F3' }} tickMargin={12} />
				<YAxis tick={axisStyle} tickLine={false} axisLine={false} width={40} />
				<Tooltip cursor={{ fill: 'rgba(0, 0, 0, 0.04)' }} />
				<Legend iconType="square" wrapperStyle={{ fontSize: 13, paddingTop: 12 }} />
				<Bar dataKey="count" name="처리량" fill="#4C8DFF" barSize={22} radius={[2, 2, 0, 0]} />
			</BarChart>
		</ResponsiveContainer>
	);
});

HourlyThroughputChart.displayName = 'HourlyThroughputChart';

export default HourlyThroughputChart;
